import { motion } from "framer-motion";
import Overline from "./Overline";
import { reveal, VIEW_80 } from "./motion";

export const AboutWhoWeAre = () => (
  <section data-testid="about-who" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={VIEW_80}>
      <Overline>Who We Are</Overline>
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-24">
        <h2 className="font-display text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
          A studio built for what comes next.
        </h2>
        <div className="space-y-6 text-sm leading-relaxed text-[#F4F6FB]/60 md:text-base">
          <p>
            Elentara operates at the intersection of cinematic art direction and real-time
            rendering. We design and engineer digital experiences — websites, installations,
            and interactive worlds — for brands that refuse to be ordinary.
          </p>
          <p>
            We believe a website can feel like a place: with depth, weather, and gravity.
            That belief shapes everything we make, from the first sketch of an idea to the
            last frame of a launch.
          </p>
        </div>
      </div>
    </motion.div>
  </section>
);

export default AboutWhoWeAre;
